import React from "react";
import { Table, Button, Icon, Dropdown, Input, Message } from "semantic-ui-react";
import { INSTRUMENTOS, aptoParaFluido } from "../catalogs/instrumentos";
import { medidorAguasAbajoValido } from "../waterBalanceCalc";
import { useWaterBalanceT } from "../useWaterBalanceT";

const FLUIDOS = ["limpia", "efluente", "canal", "vapor", "proceso", "tanque"];
const ROLES = ["entrada", "salida", "interno"];

// Paso 5 — Instrumentos y medidores propios del Balance (torre, tanque,
// submedidores). Un instrumento inadecuado no pasa nunca de grado 3, aunque
// la calibración esté vigente (Fuentes.md §3). Un medidor con padre
// declarado y rol distinto de interno es doble conteo y se bloquea.
export function InstrumentosStep({ instruments, onChange }) {
  const t = useWaterBalanceT();
  const lista = instruments || [];

  const INSTRUMENTO_OPTIONS = Object.values(INSTRUMENTOS).map((i) => ({ key: i.id, value: i.id, text: `${i.nombre} (grado ${i.grado})` }));
  const FLUIDO_OPTIONS = FLUIDOS.map((f) => ({ key: f, value: f, text: t(`water_balance_fluid_${f}`) }));
  const ROL_OPTIONS = ROLES.map((r) => ({ key: r, value: r, text: t(`water_balance_role_${r}`) }));

  const actualizar = (idx, campo, val) => onChange(lista.map((it, i) => (i === idx ? { ...it, [campo]: val } : it)));
  const agregar = () =>
    onChange([...lista, { id: `inst_${Date.now()}_${lista.length}`, name: "", instrumentType: "ninguno", fluid: "proceso", meterRole: "interno", parentMeterId: "", calibrationDue: "" }]);
  const quitar = (idx) => onChange(lista.filter((_, i) => i !== idx));

  // El motor (waterBalanceCalc.js) no se tradujo: sigue esperando
  // medidorPadreId/rolMedidor. Este es el mismo tipo de frontera de
  // traducción que estado.js#buildEstadoParaMotor.
  const esDobleConteo = (it) => !medidorAguasAbajoValido({ medidorPadreId: it.parentMeterId, rolMedidor: it.meterRole });

  return (
    <div className="water-balance-step">
      <h3>{t("water_balance_instruments_title")}</h3>
      <Table celled compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("water_balance_col_name")}</Table.HeaderCell>
            <Table.HeaderCell>{t("water_balance_col_instrument")}</Table.HeaderCell>
            <Table.HeaderCell>{t("water_balance_col_fluid")}</Table.HeaderCell>
            <Table.HeaderCell>{t("water_balance_col_role")}</Table.HeaderCell>
            <Table.HeaderCell>{t("water_balance_col_parent_meter")}</Table.HeaderCell>
            <Table.HeaderCell>{t("water_balance_col_calibration_due")}</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {lista.map((it, idx) => {
            const apto = aptoParaFluido(it.instrumentType, it.fluid);
            const dobleConteo = esDobleConteo(it);
            return (
              <React.Fragment key={idx}>
                <Table.Row warning={!apto || dobleConteo}>
                  <Table.Cell><Input transparent value={it.name} onChange={(e) => actualizar(idx, "name", e.target.value)} /></Table.Cell>
                  <Table.Cell>
                    <Dropdown selection compact options={INSTRUMENTO_OPTIONS} value={it.instrumentType} onChange={(_, d) => actualizar(idx, "instrumentType", d.value)} />
                  </Table.Cell>
                  <Table.Cell>
                    <Dropdown selection compact options={FLUIDO_OPTIONS} value={it.fluid} onChange={(_, d) => actualizar(idx, "fluid", d.value)} />
                  </Table.Cell>
                  <Table.Cell>
                    <Dropdown selection compact options={ROL_OPTIONS} value={it.meterRole} onChange={(_, d) => actualizar(idx, "meterRole", d.value)} />
                  </Table.Cell>
                  <Table.Cell><Input transparent placeholder={t("water_balance_parent_meter_placeholder")} value={it.parentMeterId || ""} onChange={(e) => actualizar(idx, "parentMeterId", e.target.value)} /></Table.Cell>
                  <Table.Cell><Input type="date" transparent value={it.calibrationDue || ""} onChange={(e) => actualizar(idx, "calibrationDue", e.target.value)} /></Table.Cell>
                  <Table.Cell><Button icon="trash" basic size="tiny" onClick={() => quitar(idx)} /></Table.Cell>
                </Table.Row>
                {!apto && (
                  <Table.Row warning>
                    <Table.Cell colSpan={7}>
                      <Icon name="warning sign" /> {t("water_balance_instrument_unfit_warning", { instrumento: INSTRUMENTOS[it.instrumentType]?.nombre, fluido: it.fluid })}
                    </Table.Cell>
                  </Table.Row>
                )}
                {dobleConteo && (
                  <Table.Row error>
                    <Table.Cell colSpan={7}><Icon name="ban" /> {t("water_balance_double_count_warning")}</Table.Cell>
                  </Table.Row>
                )}
              </React.Fragment>
            );
          })}
        </Table.Body>
      </Table>
      <Button basic onClick={agregar}><Icon name="plus" /> {t("water_balance_add_instrument_button")}</Button>

      <Message style={{ marginTop: 16 }}>{t("water_balance_instrument_grade_note")}</Message>
    </div>
  );
}

export default InstrumentosStep;
